export default "__VITE_ASSET__b1c1946f__"